module.exports = __webpack_public_path__ + "img/_lupa.8e9de055.svg";